import { CaretDownFilled, CaretUpFilled } from '@ant-design/icons';
import classNames from 'classnames';
import React, { useState } from 'react';
import styles from './Subsection.module.css';

export const Subsection = ({
  name,
  children,
  className,
  hasActiveFilters,
  hide,
  openOnMount,
}: {
  name: string;
  children: JSX.Element | JSX.Element[];
  className?: string;
  hasActiveFilters?: boolean;
  hide?: boolean;
  openOnMount?: boolean;
}) => {
  const [isExpanded, setIsExpanded] = useState(openOnMount || false);

  const hasCheckedChildCheckboxes =
    Array.isArray(children) && children.some(child => child?.props?.isChecked);

  const activeFiltersPresent = hasCheckedChildCheckboxes || hasActiveFilters;

  if (hide) {
    return <></>;
  }

  return (
    <div className={classNames(styles.container, className)}>
      <div
        className={classNames(styles.title, {
          [styles.titleExpanded]: isExpanded,
        })}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className={styles.heading}>
          {isExpanded ? (
            <CaretUpFilled className={styles.caret} />
          ) : (
            <CaretDownFilled className={styles.caret} />
          )}
          {name}
          {activeFiltersPresent && <div className={styles.activeDot} />}
        </div>
      </div>
      {isExpanded && children}
    </div>
  );
};
